/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./renderer/RenderGrid',
	'./renderer/PrintGrid',
	'../../common/PrintHelper'
], (
	RenderGrid,
	PrintGrid,
	PrintHelper
) => {

	return class GridControlUtil {

		static getGridClass (dashboard, content) {
			return PrintHelper.isRenderFullEnabled(dashboard, content) ? PrintGrid : RenderGrid;
		}
	};
});
